import {techDocWebsocketCommands} from '../../constants/techDocWebsocketCommands';

export const TECH_DOC_INTERNAL_TICKET_HISTORY_FETCH_PENDING = 'TECH_DOC_INTERNAL_TICKET_HISTORY_FETCH_PENDING';

export const fetchTechDocInternalTicketHistoryPageData = (pageSize, sorted, cursor, isNextFromPivot, filtered) => dispatch => {
    dispatch({
        type: TECH_DOC_INTERNAL_TICKET_HISTORY_FETCH_PENDING,
        techDocWebsocket: true,
        command: techDocWebsocketCommands.TECH_DOC_INTERNAL_TICKET_HISTORY_GET,
        payload: {pageSize: pageSize, sorted: sorted, cursor, isNextFromPivot, filtered: filtered}
    });
};
